import React, { useState } from 'react';
import { AVAILABLE_PROMPTS } from '../types/prompts';
import PromptDocsModal from './PromptDocsModal';
import WorkblocksModal from './WorkblocksModal';

interface PromptDocsButtonProps {
  selectedUserId: string;
  selectedDate: string;
}

const PromptDocsButton: React.FC<PromptDocsButtonProps> = ({ selectedUserId, selectedDate }) => {
  const [selectedPrompt, setSelectedPrompt] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isWorkblocksModalOpen, setIsWorkblocksModalOpen] = useState(false);

  const handlePromptClick = (promptName: string) => {
    setSelectedPrompt(promptName);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPrompt(null);
  };

  const handleWorkblocksClick = () => {
    setIsWorkblocksModalOpen(true);
  };

  const handleWorkblocksModalClose = () => {
    setIsWorkblocksModalOpen(false);
  };

  return (
    <>
      <div className="prompt-docs-section">
        <div className="prompt-docs-header">
          <h4>Prompts</h4>
          <p>View system prompts and raw data</p>
        </div>
        
        <div className="prompt-buttons-grid">
          {AVAILABLE_PROMPTS.map((prompt) => (
            <button
              key={prompt.name}
              className="prompt-doc-btn"
              onClick={() => handlePromptClick(prompt.name)}
              title={prompt.description}
            >
              <div className="prompt-btn-content">
                <div className="prompt-btn-label">{prompt.name}</div>
              </div>
            </button>
          ))}
        </div>
        
        <div className="raw-data-section">
          <button
            className="view-raw-workblocks-btn"
            onClick={handleWorkblocksClick}
            title="View all generated files and reports"
          >
            View Generated Files
          </button>
        </div>
      </div>

      {selectedPrompt && (
        <PromptDocsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          promptName={selectedPrompt}
        />
      )}

      <WorkblocksModal
        isOpen={isWorkblocksModalOpen}
        onClose={handleWorkblocksModalClose}
        userId={selectedUserId}
        selectedDate={selectedDate}
      />
    </>
  );
};

export default PromptDocsButton;
